import { Location } from "./Location";

export const INITIAL_VALUES: Location = {
	locationId: 0,
	locationName: "",
	locationTypeId: 0,
	rootTypeId: 0,
	isActive: true,
	sortOrder: 1,
};
